<template>
  <div class="box">
    <!-- 搜索 -->
    <div class="search">
      <div class="search-left">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <div class="search-left-top">
            <el-form-item label="书名">
              <el-input
                v-model="formInline.title"
                placeholder="书名"
              ></el-input>
            </el-form-item>
            <el-form-item label="类别">
              <el-cascader
                :props="categoryProps"
                @change="changeCategories"
                v-model="categoryData"
                :options="options"
              ></el-cascader>
            </el-form-item>
          </div>
          <div class="search-left-bottom"></div>
          <el-form-item label="朝代类别">
            <el-select v-model="formInline.dynasty">
              <el-option
                v-for="item in dynasty"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="formInline.status">
              <el-option
                v-for="item in status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="search-right">
        <el-button type="primary" @click="search">查询</el-button>
      </div>
    </div>
    <!-- 标题 -->
    <div class="title">
      <div>古籍列表</div>
    </div>
    <!-- 列表 -->
    <el-table :data="tableData" style="width: 100%" v-loading="loading">
      <el-table-column prop="id" label="ID" align="center" width="80">
      </el-table-column>
      <el-table-column prop="name" label="书名" align="center" width="100">
      </el-table-column>
      <el-table-column prop="author" label="作者" align="center" width="100">
      </el-table-column>
      <el-table-column label="库别" align="center" width="150">
        <span>孤本库</span>
      </el-table-column>
      <el-table-column
        prop="category_name"
        label="类别"
        align="center"
        width="180"
      >
      </el-table-column>
      <el-table-column prop="dynasty" label="朝代" align="center" width="100">
      </el-table-column>
      <el-table-column prop="price" label="定价" align="center" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.is_default_price == 1"
            >{{ scope.row.price }} 元（默认）</span
          >
          <span v-if="scope.row.is_default_price == 0"
            >{{ scope.row.price }} 元（自定义）</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="discount_type"
        label="收费类型"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <span>{{ getSflx(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="conf" label="试读设置" align="center" width="200">
        <template slot-scope="scope">
          <span>{{ getConf(scope.row.conf) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="detail(scope.row, 1)">详情</el-button>
          <el-button type="text" @click="detail(scope.row, 2)">编辑</el-button>
          <el-button
            type="text"
            v-if="scope.row.is_shelf == 1"
            @click="isShelf(scope.row)"
            >下架</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.is_shelf == 0"
            @click="isShelf(scope.row)"
            >上架</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="totalPages > 1">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="page_size"
        :total="pageTotal"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>
    <!-- 详情 -->

    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
      :title="editTitle"
      center
    >
      <el-form ref="ruleForm" :model="form" label-width="180px">
        <el-form-item label="古籍ID：">
          <el-input
            type="text"
            disabled="disabled"
            v-model="form.id"
          ></el-input>
        </el-form-item>
        <el-form-item label="书名：">
          <el-input type="text" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="作者：">
          <el-input type="text" v-model="form.author"></el-input>
        </el-form-item>
        <el-form-item label="馆藏地：">
          <el-input type="text" v-model="form.book_id"></el-input>
        </el-form-item>
        <el-form-item label="朝代：">
          <el-input type="text" v-model="form.dynasty"></el-input>
        </el-form-item>
        <el-form-item label="所在册：">
          <el-input
            type="text"
            disabled="disabled"
            v-model="form.volumes"
          ></el-input>
        </el-form-item>
        <el-form-item label="库别：">
          <el-select
            v-model="f_ku_type"
            class="handle-select"
            @change="selectChange(1, $event)"
          >
            <el-option
              v-for="(child, index) in fku_type"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类目：">
          <el-cascader
            v-model="form.category_info"
            :options="options1"
            :props="categoryProps1"
            :show-all-levels="false"
            @change="caChange($event)"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="朝代类别：">
          <el-select
            v-model="form.dynasty_id"
            class="handle-select"
            @change="selectChange(3, $event)"
          >
            <el-option
              v-for="child in dynasty_type"
              :key="child.id"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签：">
          <div
            v-for="(item, i) in form.labels"
            :key="i"
            style="margin-bottom: 10px;display: flex;align-items: center;"
          >
            <el-select v-model="item.type" class="handle-select">
              <el-option
                v-for="(child, index) in bqList"
                :key="index"
                :label="child.label"
                :value="child.value"
              ></el-option>
            </el-select>
            <el-input
              type="text"
              v-model="item.title"
              style="width:200px;margin-left: 10px;margin-right: 10px;"
            ></el-input>
            <el-button type="primary" @click="delBq(i)">删 除</el-button>
          </div>
          <el-button type="primary" @click="addBq">添 加</el-button>
        </el-form-item>
        <el-form-item label="定价：">
          <div style="display: flex">
            <el-select
              v-model="f_price"
              class="handle-select"
              @change="selectChange(4, $event)"
            >
              <el-option
                v-for="(child, index) in priceList"
                :key="index"
                :label="child.label"
                :value="child.value"
              ></el-option>
            </el-select>
            <span
              v-if="f_price == 0"
              style="display: flex; justify-content: center; margin-left: 50px"
            >
              <el-input
                v-model="form.price"
                type="text"
                style="margin-right: 10px"
              ></el-input
              >元
            </span>
          </div>
        </el-form-item>
        <div style="display: flex; flex-direction: column; align-items: center">
          <div style="width: 100%; display: flex; align-items: center">
            <el-form-item label="免费状态：" style="margin-bottom: 0">
              <el-select
                v-model="f_discount_type"
                class="handle-select"
                @change="selectChange(5, $event)"
              >
                <el-option
                  v-for="child in free_status"
                  :key="child.value"
                  :label="child.label"
                  :value="child.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <span
              v-if="f_discount_type == 3 || f_discount_type == 4"
              style="display: flex; align-items: center; margin-left: 50px"
            >
              <el-input
                v-model="form.discount.discount"
                type="text"
                style="margin-right: 10px"
              ></el-input
              >折
            </span>
          </div>

          <el-date-picker
            v-if="f_discount_type == 2 || f_discount_type == 4"
            class="handle-date mr10"
            style="margin: 20px 140px 0px 0px"
            v-model="form.date"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd hh:mm:ss"
            @change="dateChange()"
          >
            >
          </el-date-picker>
        </div>
        <el-form-item label="试读设置：" style="margin-top: 20px">
          <div style="display: flex">
            <el-select
              v-model="f_tryRead"
              class="handle-select"
              @change="selectChange(6, $event)"
            >
              <el-option
                v-for="(child, index) in tryRead"
                :key="index"
                :label="child.label"
                :value="child.value"
              ></el-option>
            </el-select>
            <span
              v-if="f_tryRead == 1"
              style="display: flex; justify-content: center; margin-left: 50px"
            >
              <el-input v-model="config_obj.size" type="text">
                <template slot="append">个</template>
              </el-input>
              <el-input
                style="margin-left:10px"
                v-model="config_obj.images"
                type="text"
              >
                <template slot="append">张</template>
              </el-input>
            </span>
            <span
              v-if="f_tryRead == 2"
              style="display: flex; justify-content: center; margin-left: 50px"
            >
              <el-input v-model="config_obj.percent" type="text">
                <template slot="append">%</template>
              </el-input>
            </span>
          </div>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <span
        v-if="is_add == false"
        slot="footer"
        class="dialog-footer self-dialog-footer"
      >
        <el-button type="primary" @click="saveEdit('ruleForm')"
          >保 存</el-button
        >
        <el-button type="primary" @click="editVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 上/下架 -->
    <el-dialog title="提示" :visible.sync="isShelfDialog" width="30%">
      <span v-if="is_shelf == 1">
        下架后，已购买该资源的用户将无法阅读。
        <br />
        请谨慎操作！
      </span>
      <span v-else> 是否确认上架该资源。 </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShelfDialog = false">取 消</el-button>
        <el-button type="primary" @click="confirmIsShelf()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/zkApiConfig";
export default {
  data() {
    return {
      id: "",
      // ----------------搜索----------------
      formInline: {
        ku_type: 1,
        category_id: "",
        dynasty: "",
      },
      //   库别
      ku_type: [
        {
          value: 1,
          label: "基础库",
        },
        {
          value: 2,
          label: "域外库",
        },
        {
          value: 3,
          label: "孤本库",
        },
      ],
      //   类别
      categoryData: [],
      options1: [],
      categoryProps1: {
        label: "name", // 字段必须统一
        value: "id", // 字段必须统一
        children: "sub_items",
      },
      category_ids: "",
      options: [],
      categoryProps: {
        label: "name", // 字段必须统一
        value: "id", // 字段必须统一
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          http
            .get("/admin/admin_books/wq_categories", {
              params: { pid: node.data.id },
            })
            .then((res) => {
              setTimeout(() => {
                console.log(res);
                const nodes = res.data.data.map((item) => ({
                  id: item.id,
                  name: item.name,
                  leaf: level >= 1,
                }));
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }, 1000);
            });
        },
      },
      //   朝代
      dynasty: [],
      //   状态
      status: [
        {
          value: 1,
          label: "已上架",
        },
        {
          value: 2,
          label: "已下架",
        },
      ],
      //   收费类型
      price_type: [
        {
          value: 1,
          label: "免费",
        },
        {
          value: 2,
          label: "定时免费",
        },
        {
          value: 3,
          label: "折扣",
        },
        {
          value: 4,
          label: "付费",
        },
      ],
      // ----------------列表----------------
      tableData: [],
      // ----------------详情----------------
      form: {
        leim_type: 1,
        ku_type: 1,
      },
      // f_dynasty_type: 13,
      editVisible: false,
      is_add: false,
      editTitle: "",
      //  库别
      f_ku_type: 3,
      fku_type: [
        {
          value: 1,
          label: "基础库",
        },
        {
          value: 2,
          label: "域外库",
        },
        {
          value: 3,
          label: "孤本库",
        },
      ],
      // 标签
      labels: "",
      bqList: [
        {
          value: "1",
          label: "书名",
        },
        {
          value: "2",
          label: "书目",
        },
        {
          value: "3",
          label: "作者",
        },
        {
          value: "4",
          label: "科室",
        },
        {
          value: "5",
          label: "医生",
        },
        {
          value: "6",
          label: "出处",
        },
        {
          value: "7",
          label: "疾病",
        },
        {
          value: "9",
          label: "功效",
        },
        {
          value: "10",
          label: "经络",
        },
        {
          value: "11",
          label: "朝代",
        },
        {
          value: "12",
          label: "方剂名",
        },
        {
          value: "13",
          label: "中药名称",
        },
        {
          value: "14",
          label: "经穴名称",
        },
      ],
      // 类目
      f_leim_type: 1,
      leimu_type: [],
      //   朝代类别
      f_dynasty_type: 13,
      dynasty_type: [],
      //   定价
      priceList: [
        {
          value: 0,
          label: "自定义",
        },
        {
          value: 1,
          label: "默认公式",
        },
      ],
      f_price: 0,
      //   免费状态
      f_discount_type: 1,
      free_status: [
        {
          value: 0,
          label: "无优惠",
        },
        {
          value: 1,
          label: "免费",
        },
        {
          value: 2,
          label: "限时免费",
        },
        {
          value: 3,
          label: "折扣",
        },
        {
          value: 4,
          label: "限时折扣",
        },
      ],
      //   试读设置
      tryRead: [
        {
          value: 0,
          label: "默认",
        },
        {
          value: 1,
          label: "按字数(图片)",
        },
        {
          value: 2,
          label: "按百分比",
        },
      ],
      f_tryRead: 0,
      config_obj: {},
      //   分页
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 10,
      //  ----------------dialog----------------
      //   上下架
      isShelfDialog: false,
      is_shelf: "",
      loading: false,
    };
  },
  mounted() {
    this.getDefault();
    this.dynasties();
    this.getData();
  },
  methods: {
    caChange(e) {
      for (let i = 0; i < e.length; i++) {
        this.category_ids = e[1];
      }
    },
    getData() {
      // 列表
      http.get("/admin/categories/wq_categories").then((res) => {
        if (res.data.status_code == 200) {
          this.options1 = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    addBq() {
      var newItem = { bq_name: "", leiMu: "" };
      this.form.labels.push(newItem);
    },
    delBq(i) {
      this.form.labels.splice(i, 1);
    },
    getSflx(row) {
      if (row.discount_type == 0) {
        return "无优惠";
      } else if (row.discount_type == 1) {
        return "免费";
      } else if (row.discount_type == 2) {
        return (
          row.discount.begin_time + "~" + row.discount.end_time + "\n限时免费"
        );
      } else if (row.discount_type == 3) {
        return row.discount.discount + "\n折扣";
      } else if (row.discount_type == 4) {
        return (
          row.discount.begin_time +
          "~" +
          row.discount.end_time +
          "\n" +
          row.discount.discount +
          "%" +
          "\n限时折扣"
        );
      }
    },
    getConf(row) {
      if (row.is_default == 0) {
        if (row.config_obj.size == "") {
          return row.config_obj.percent + "%";
        } else {
          return (
            "文字:" +
            row.config_obj.size +
            "字\n" +
            "图片:" +
            row.config_obj.images +
            "张"
          );
        }
      } else if (row.is_default == 1) {
        if (row.config_obj.size == "") {
          return row.config_obj.percent + "%" + "\n(默认)";
        } else {
          return (
            "文字:" +
            row.config_obj.size +
            "字\n" +
            "图片:" +
            row.config_obj.images +
            "张" +
            "\n(默认)"
          );
        }
      }
    },
    // 时间
    dateChange() {
      console.log(this.form.date, "e");
      this.form.discount.begin_time = this.form.date[0];
      this.form.discount.end_time = this.form.date[1];
    },
    selectChange(type, e) {
      if (type == 1) {
        this.form.ku_type == e;
      } else if (type == 2) {
        this.form.leim_type == e;
      } else if (type == 3) {
        this.form.dynasty_type == e;
      } else if (type == 4) {
        this.form.price_type == e;
        if (this.form.price_type == 1) {
          this.form.price = 29.9;
        }
      } else if (type == 5) {
        this.form.discount_type == e;
      } else if (type == 6) {
        this.form.tryRead_type == e;
      }
    },
    // 朝代
    dynasties() {
      http.get("/admin/admin_books/dynasties").then((res) => {
        if (res.data.status_code == 200) {
          this.dynasty = res.data.data;
          this.dynasty_type = res.data.data;
        }
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getDefault();
    },
    getDefault() {
      // 域外分类
      let pid = 0;
      http
        .get("/admin/admin_books/wq_categories", { params: { pid: pid } })
        .then((res) => {
          if (res.data.status_code == 200) {
            this.options = res.data.data;
          }
        });
      let params = {
        page: this.currentPage,
        page_size: this.page_size,
        title: this.formInline.title,
        category_id: this.formInline.category_id,
        is_shelf: this.formInline.status,
      };
      http.get("/admin/admin_books/wq_list", { params: params }).then((res) => {
        if (res.data.status_code == 200) {
          this.tableData = res.data.data.data;
          this.currentPage = Number(res.data.data.current_page);
          this.totalPages = res.data.data.last_page;
          this.pageTotal = this.totalPages * this.page_size;
          this.loading = false;
        }
      });
    },
    changeCategories(e) {
      console.log(e, "e");
      console.log(this.categoryData, "categoryData");
      console.log(this.options, "options");
      var arr = e;
      this.formInline.category_id = arr[arr.length - 1];
    },
    search() {
      this.currentPage = 1;
      this.getDefault();
    },
    detail(row, type) {
      console.log(row, "row1");
      if (type == 1) {
        this.is_add = true;
        this.editTitle = "古籍详情页";
        this.editVisible = true;
      } else {
        this.id = row.id;
        this.is_add = false;
        this.editTitle = "古籍编辑页";
        this.editVisible = true;
      }
      http
        .get("/admin/admin_books/wq_info", { params: { book_id: row.id } })
        .then((res) => {
          if (res.data.status_code == 200) {
            this.form = res.data.data;
            this.f_discount_type = this.form.discount_type;
            let data = res.data.data;
            // 类目
            for (let i = 0; i < data.category_info.length; i++) {
              this.category_ids = data.category_info[1];
            }
            // 免费状态
            if (data.discount_type == 0) {
              this.form.discount_type = "无优惠";
            } else if (data.discount_type == 1) {
              this.form.discount_type = "免费";
            } else if (data.discount_type == 2) {
              this.form.discount_type = "限时免费";
              this.$set(this.form, "date", [
                data.discount.begin_time,
                data.discount.end_time,
              ]);
            } else {
              this.form.discount_type = "限时折扣";
              this.$set(this.form, "date", [
                data.discount.begin_time,
                data.discount.end_time,
              ]);
            }
            // 定价
            if (data.is_default_price == 0) {
              this.f_price = 0;
            } else if (data.is_default_price == 1) {
              this.f_price = 1;
            }
            // 试读设置
            if (data.conf.is_default == 1) {
              this.f_tryRead = 0;
            } else if (data.conf.is_default == 0) {
              if (data.conf.size == "") {
                this.f_tryRead = 2;
              } else {
                this.f_tryRead = 1;
              }
            }
          }
        });
    },
    getDown() {},
    isShelf(row) {
      this.id = row.id;
      this.is_shelf = row.is_shelf;
      this.isShelfDialog = true;
    },
    saveEdit() {
      let labels = this.form.labels;
      let data = "";
      var data1 = "";
      for (let i = 0; i < labels.length; i++) {
        data = labels[i].type + "_" + labels[i].title + ",";
        data1 += data;
      }
      data1 = data1.substring(0, data1.length - 1);
      if (this.f_tryRead == 1) {
        this.form.conf.config_obj.percent = "";
      } else if (this.f_tryRead == 2) {
        this.form.conf.config_obj.size = "";
        this.form.conf.config_obj.images = "";
      }
      let params = {
        name: this.form.name,
        author: this.form.author,
        cover: this.form.cover,
        price: this.form.price,
        discount_type: this.f_discount_type,
        book_version: this.form.version,
        collect: this.form.collect,
        volumes: this.form.volumes,
        comment: this.form.comment,
        summary: this.form.summary,
        sequence_number: this.form.sequence_number,
        percent: this.f_tryRead != 0 ? this.form.conf.config_obj.percent : "",
        size: this.f_tryRead != 0 ? this.form.conf.config_obj.size : "",
        images: this.f_tryRead != 0 ? this.form.conf.config_obj.images : "",
        labels: data1,
        category_id: this.category_ids,
        start_time:
          this.f_discount_type == 2 || this.f_discount_type == 4
            ? this.form.discount.begin_time
            : "",
        end_time:
          this.f_discount_type == 2 || this.f_discount_type == 4
            ? this.form.discount.end_time
            : "",
        dynasty: this.form.dynasty,
        discount:
          this.f_discount_type == 2 || this.f_discount_type == 4
            ? this.form.discount.discount
            : "",
        is_default_conf: this.f_tryRead,
        dynasty_id: this.form.dynasty_id,
        remark: this.form.remark,
      };
      http.put("/admin/admin_books/wq_edit/" + this.id, params).then((res) => {
        if (res.data.status_code == 200) {
          this.editVisible = false;
          this.getDefault();
          this.$message.success("保存成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    confirmIsShelf() {
      http.put("/admin/admin_books/zk_shelf/" + this.id).then((res) => {
        if (res.data.status_code == 200) {
          this.isShelfDialog = false;
          if (this.is_shelf == 1) {
            this.getDefault();
            this.$message.success("已下架");
          } else if (this.is_shelf == 0) {
            this.getDefault();
            this.$message.success("已上架");
          } else {
            this.$message.error(res.data.msg);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.box {
  width: 100%;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
}
.search {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.search-left {
  width: 70%;
  display: flex;
  flex-wrap: wrap;
}
.search-left-top {
  width: 100%;
}
.search-left-bottom {
  width: 100%;
}
.title {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  font-weight: bold;
}
.button {
  float: right;
}
.nBuild-title {
  padding: 20px;
  color: #169bd5;
}
.border {
  width: 100%;
  height: 1px;
  margin: 10px 0;
  background-image: linear-gradient(
    to right,
    rgb(121, 121, 121) 0%,
    rgb(121, 121, 121) 50%,
    transparent 50%
  );
  background-size: 20px 2px;
  background-repeat: repeat-x;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border: 1px solid #000;
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
